module.exports = __webpack_public_path__ + "85d3a12779512d803281a7cb61aba4c5.svg";